import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout'; 

const Home = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div
        className="relative text-center p-16 lg:p-32 min-h-[85vh] flex items-center justify-center overflow-hidden" 
        style={{
          backgroundImage: "url('/images/lux-dog-grooming.jpg')", 
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Overlay: Keep the overlay to ensure readability, but maybe adjust opacity slightly */}
        <div className="absolute inset-0 bg-black opacity-70 pointer-events-none z-0" /> {/* Slightly reduced opacity */}

        {/* Content Layer */}
        <div className="relative z-10 max-w-4xl mx-auto">
          
          {/* Main Title: Now with a fading gradient effect */}
          <h1 
            className="text-6xl lg:text-8xl font-sans font-extrabold tracking-tight leading-none"
            style={{
              // Use a linear gradient for the text color
              backgroundImage: 'linear-gradient(to right, #FFF 0%, rgba(255, 255, 255, 0.5) 70%, rgba(255, 255, 255, 0) 100%)', // Fades from white to semi-transparent to fully transparent
              WebkitBackgroundClip: 'text', // Clip background to text shape
              WebkitTextFillColor: 'transparent', // Make text transparent so background shows through
              // Add a subtle text shadow for better readability against complex backgrounds
              textShadow: '2px 2px 8px rgba(0,0,0,0.6)', 
            }}
          >
            Paws & Polish. 🐾
          </h1>
          
          {/* Subtitle: Highlighting the luxury grooming and Dogecoin integration */}
          <p className="mt-6 text-xl lg:text-3xl font-light text-yellow-300"> 
            Premier Canine Styling. **Payments in DOGE Accepted.**
          </p>

          {/* Payment Messaging */}
          <div className="mt-10 text-center max-w-2xl mx-auto">
             <p className="text-lg lg:text-xl text-gray-200 border-t pt-4 border-yellow-400/50">
                Give your best friend the pampering they deserve. We happily accept fiat and **Dogecoin** for all services!
             </p>
          </div>

          {/* --- Primary Action: Booking with Dogecoin Emphasis --- */}
          <button
            onClick={() => navigate('/book')}
            className="mt-12 px-12 py-5 bg-yellow-400 text-gray-900 text-2xl font-bold uppercase rounded-full shadow-2xl hover:bg-yellow-500 transition duration-300 transform hover:scale-105"
            style={{
              border: '2px solid #FFD700', 
              letterSpacing: '2px',
            }}
          >
            Schedule a Pamper Session (DOGE Welcome!)
          </button>

          {/* --- Secondary Action: Wallet/Loyalty/Exclusive Services for Doge Holders --- */}
          <div className="mt-20 space-y-4">
            <p className="text-gray-200 text-xl font-medium">
                Exclusive Perks for Our Pack Leaders.
            </p>
            <button
              onClick={() => navigate('/doge-club')} 
              className="text-blue-400 hover:text-blue-300 text-2xl font-bold transition duration-300 border-b border-dashed border-blue-400"
            >
              Join the **DOGE VIP Club**
            </button>
            <p className="text-gray-400 text-sm italic mt-2">
                Connect your crypto wallet to unlock special offers, early access, and unique treats for your pup!
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
